var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configuration"},[_c('Table',{attrs:{"loading":_vm.loading,"columns":_vm.recordsCol,"data":_vm.ConnectionssData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }